// Fallback until the status response carries lead_limit (api ships first).
export const AH_MONTHLY_LEAD_LIMIT = 5;

export const QUERY_AH_STATUS = ["AFFORDABLE_HOUSING_COM", "STATUS"] as const;

export const AH_DISCLOSURE_FREE_PLAN =
  "AffordableHousing.com's free plan includes 5 leads per month.";

export const AH_DISCLOSURE_PAID_PLAN =
  "Receiving more than 5 leads in a month requires a paid AffordableHousing.com subscription, purchased directly with AffordableHousing.com — not through Boom.";

export const AH_LIMIT_REACHED_MESSAGE =
  "You've reached AffordableHousing.com's free monthly limit of 5 leads. To keep receiving leads, upgrade your plan directly with AffordableHousing.com.";
